<template>
  <div style="width: 1000px;margin: 0 auto">
    <div class="title">
      {{ form.title }}
    </div>
    <div class="titleTime">
      <span>发布时间：{{ form.createTime.substring(0, 10) }}</span>
    </div>
    <el-divider />
    <div style="padding: 20px">
      <span class="XQtext" v-html="form.content" />
    </div>
  </div>
</template>

<script>
import { find } from '@/api/news.js'
import { richReplace, richReplaceNotAll } from '@/utils/rich-replace'
export default {
  name: 'news',
  data () {
    return {
      form: {}
    }
  },
  created () {
    find({ id: this.$route.query.id }).then(response => {
      this.form = response.data
      this.form.content = richReplaceNotAll(this.form.content)
      this.form.content = richReplace(this.form.content)
    })
  }
}
</script>

<style scoped>
  .title{
    width: 1000px;
    text-align: center;
    margin-top: 20px;
    font-size: 24px;
    font-weight: 600;
  }
  .titleTime{
    width: 1000px;
    text-align: center;
    margin-top: 20px;
    font-size: 14px;
    color: #999999;
  }
  .XQtext{
    padding: 0 20px;
    line-height: 28px;
    font-size: 16px;
    color: #333333;
  }
</style>



// WEBPACK FOOTER //
// src/components/computer/news.vue